// removed by extract-text-webpack-plugin
module.exports = {"blcDocument":"AttachmentList__blcDocument___3IsPm"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/EditComplaint/AttachmentList/AttachmentList.scss
// module id = 736
// module chunks = 0